// @ts-check

import { createWidget } from "@opendash/core";



export default createWidget({
  type: "opendash-widget-bcm-shipping",
  meta: {},
  displayComponent: () => import("./component"),
  settingsComponent: () => import("./settings"),
  presets: [
    {
      label: "bcm:widgets.shipping.name",
      description: "bcm:widgets.shipping.description",
      imageLink: require("./screenshot.png"),
      layout: [6, 8],
      widget: {
        config: {
          blocklist: [],
        },
      },
    },
  ],
});
